module.exports = __webpack_public_path__ + "static/media/hw-logo.83b60e38.png";